import { useNavigate } from 'react-router'

const icon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='233'
    height='155'
    viewBox='0 0 233 155'
    fill='none'
  >
    <path
      d='M194.729 31.0073C196.469 31.0073 197.88 29.5965 197.88 27.8563C197.88 26.1161 196.469 24.7054 194.729 24.7054C192.988 24.7054 191.578 26.1161 191.578 27.8563C191.578 29.5965 192.988 31.0073 194.729 31.0073Z'
      fill='#D30138'
    />
    <path
      d='M207.332 50.5431C210.116 50.5431 212.374 48.2859 212.374 45.5016C212.374 42.7172 210.116 40.4601 207.332 40.4601C204.548 40.4601 202.291 42.7172 202.291 45.5016C202.291 48.2859 204.548 50.5431 207.332 50.5431Z'
      fill='#D30138'
    />
    <path
      d='M198.51 65.6676C199.902 65.6676 201.03 64.539 201.03 63.1469C201.03 61.7547 199.902 60.6261 198.51 60.6261C197.117 60.6261 195.989 61.7547 195.989 63.1469C195.989 64.539 197.117 65.6676 198.51 65.6676Z'
      fill='#D30138'
    />
    <path
      d='M12.6037 72.5997C15.04 72.5997 17.015 70.6247 17.015 68.1884C17.015 65.7521 15.04 63.7771 12.6037 63.7771C10.1674 63.7771 8.19238 65.7521 8.19238 68.1884C8.19238 70.6247 10.1674 72.5997 12.6037 72.5997Z'
      fill='#D30138'
    />
    <path
      d='M2.52076 90.8752C3.91293 90.8752 5.04151 89.7466 5.04151 88.3544C5.04151 86.9623 3.91293 85.8337 2.52076 85.8337C1.12858 85.8337 0 86.9623 0 88.3544C0 89.7466 1.12858 90.8752 2.52076 90.8752Z'
      fill='#D30138'
    />
    <path
      d='M170.906 0H35.045C27.3885 0 21.1816 6.20684 21.1816 13.8634V124.77C21.1816 132.427 27.3885 138.634 35.045 138.634H170.906C178.563 138.634 184.769 132.427 184.769 124.77V13.8634C184.769 6.20684 178.563 0 170.906 0Z'
      fill='#D4E5F7'
    />
    <path
      d='M170.906 0H35.045C27.3885 0 21.1816 6.20684 21.1816 13.8634V24.9541C21.1816 32.6106 27.3885 38.8174 35.045 38.8174H170.906C178.563 38.8174 184.769 32.6106 184.769 24.9541V13.8634C184.769 6.20684 178.563 0 170.906 0Z'
      fill='#0055B8'
    />
    <path d='M184.769 27.7283H21.1816V38.819H184.769V27.7283Z' fill='#0055B8' />
    <path
      d='M43.3633 26.3391C47.1916 26.3391 50.295 23.2357 50.295 19.4075C50.295 15.5792 47.1916 12.4758 43.3633 12.4758C39.5351 12.4758 36.4316 15.5792 36.4316 19.4075C36.4316 23.2357 39.5351 26.3391 43.3633 26.3391Z'
      fill='white'
    />
    <path
      d='M62.772 26.3391C66.6003 26.3391 69.7037 23.2357 69.7037 19.4075C69.7037 15.5792 66.6003 12.4758 62.772 12.4758C58.9438 12.4758 55.8403 15.5792 55.8403 19.4075C55.8403 23.2357 58.9438 26.3391 62.772 26.3391Z'
      fill='white'
    />
    <path
      d='M82.1802 26.3391C86.0085 26.3391 89.1119 23.2357 89.1119 19.4075C89.1119 15.5792 86.0085 12.4758 82.1802 12.4758C78.352 12.4758 75.2485 15.5792 75.2485 19.4075C75.2485 23.2357 78.352 26.3391 82.1802 26.3391Z'
      fill='white'
    />
    <path
      d='M159.815 9.70886H109.907C105.313 9.70886 101.589 13.433 101.589 18.0269C101.589 22.6208 105.313 26.3449 109.907 26.3449H159.815C164.409 26.3449 168.133 22.6208 168.133 18.0269C168.133 13.433 164.409 9.70886 159.815 9.70886Z'
      fill='white'
    />
    <path
      d='M69.3268 62.2599L61.2551 64.2692C59.0261 64.824 57.669 67.0807 58.2239 69.3096C58.7787 71.5386 61.0354 72.8957 63.2644 72.3408L71.3361 70.3315C73.565 69.7767 74.9221 67.52 74.3673 65.291C73.8124 63.0621 71.5557 61.705 69.3268 62.2599Z'
      fill='#94A3B8'
    />
    <path
      d='M112.625 64.7731L104.645 62.4286C102.441 61.7812 100.129 63.0429 99.482 65.2467C98.8346 67.4506 100.096 69.762 102.3 70.4094L110.281 72.7539C112.485 73.4013 114.796 72.1396 115.444 69.9357C116.091 67.7319 114.829 65.4205 112.625 64.7731Z'
      fill='#94A3B8'
    />
    <path
      d='M118.73 105.415C120.107 105.898 121.617 105.174 122.101 103.796C122.585 102.419 121.86 100.909 120.483 100.425C110.225 96.8214 100.48 96.0187 91.3255 98.1763C82.1706 100.334 73.8106 105.403 66.242 113.208C65.2255 114.256 65.2512 115.931 66.2993 116.947C67.3475 117.963 69.0217 117.938 70.0382 116.89C77.0371 109.672 84.5383 105.209 92.5384 103.323C100.539 101.438 109.244 102.082 118.73 105.415Z'
      fill='#94A3B8'
    />
    <path
      d='M178.974 152.797C208.21 152.797 231.91 129.097 231.91 99.861C231.91 70.6254 208.21 46.9252 178.974 46.9252C149.738 46.9252 126.038 70.6254 126.038 99.861C126.038 129.097 149.738 152.797 178.974 152.797Z'
      fill='white'
    />
    <path
      d='M141.034 108.899V104.709L153.378 85.206H156.872V91.1719H154.742L146.432 104.339V104.567H163.662V108.899H141.034ZM154.912 114.297V107.621L154.969 105.746V85.206H159.941V114.297H154.912ZM178.953 114.851C176.614 114.851 174.607 114.259 172.931 113.075C171.264 111.882 169.981 110.163 169.081 107.919C168.191 105.665 167.746 102.952 167.746 99.7798C167.755 96.6075 168.205 93.9086 169.095 91.6832C169.995 89.4484 171.278 87.7438 172.945 86.5696C174.621 85.3954 176.624 84.8082 178.953 84.8082C181.283 84.8082 183.286 85.3954 184.962 86.5696C186.638 87.7438 187.921 89.4484 188.811 91.6832C189.711 93.9181 190.161 96.617 190.161 99.7798C190.161 102.962 189.711 105.679 188.811 107.933C187.921 110.178 186.638 111.892 184.962 113.075C183.295 114.259 181.292 114.851 178.953 114.851ZM178.953 110.405C180.771 110.405 182.206 109.51 183.257 107.72C184.318 105.921 184.848 103.274 184.848 99.7798C184.848 97.4692 184.607 95.5279 184.124 93.956C183.641 92.384 182.959 91.2003 182.078 90.4048C181.198 89.5999 180.156 89.1974 178.953 89.1974C177.145 89.1974 175.715 90.0971 174.664 91.8963C173.612 93.6861 173.082 96.3139 173.073 99.7798C173.063 102.1 173.295 104.051 173.769 105.632C174.252 107.214 174.933 108.407 175.814 109.212C176.695 110.007 177.741 110.405 178.953 110.405ZM194.355 108.899V104.709L206.698 85.206H210.193V91.1719H208.062L199.752 104.339V104.567H216.982V108.899H194.355ZM208.232 114.297V107.621L208.289 105.746V85.206H213.261V114.297H208.232Z'
      fill='#B42318'
    />
    <path
      d='M178.955 153.477C208.226 153.477 231.955 129.748 231.955 100.477C231.955 71.2055 208.226 47.4766 178.955 47.4766C149.684 47.4766 125.955 71.2055 125.955 100.477C125.955 129.748 149.684 153.477 178.955 153.477Z'
      stroke='#E4E4EE'
      stroke-width='1.89057'
    />
  </svg>
)
const PageNotFound = () => {
  const navigate = useNavigate()
  return (
    <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'>
      <div className='flex flex-col items-center justify-center gap-[2.75rem] p-[1.875rem] rounded-[0.625rem] bg-primary shadow-lg'>
        <div className='flex flex-col items-center gap-[1.5rem]'>
          {icon}
          <div className='flex flex-col items-center gap-[0.75rem]'>
            <p className='text-primary-foreground text-[2.375rem] font-bold'>
              Page Not Found
            </p>
            <p className='text-primary-foreground text-[1.25rem]'>
              The route you requested doesn't exist.
            </p>
          </div>
        </div>
        <div className='flex items-center justify-center py-[0.75rem] px-[1.5rem] rounded-[0.5rem] bg-accent shadow-sm cursor-pointer'>
          <button
            className='text-accent-foreground font-semibold cursor-pointer'
            onClick={() => {
              navigate('/home')
            }}
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  )
}

export default PageNotFound
